
import React from 'react';
import ListingsManagement from '@/components/admin/ListingsManagement';

const ListingsManagementPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Listings Management</h1>
        <p className="text-muted-foreground">
          View and manage all property listings
        </p>
      </div>
      <ListingsManagement />
    </div>
  );
};

export default ListingsManagementPage;
